import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { db } from "../../../firebase";
import Loading from "../../Atoms/loading/Loading";

function SkillsList() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [availiableSkills, setAvailiableSkills] = useState([]);

  useEffect(() => {
    setLoading(true);
    setAvailiableSkills([]);
    const fetchData = async () => {
      try {
        const snapShot = await db
          .collection("HomePageData")
          .doc("ScreenData")
          .get();
        setAvailiableSkills(snapShot.data().SkillCategory);
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="skillsList">
          {availiableSkills.map((item) => (
            <div
              key={item}
              className="skillsList__skillBox"
              onClick={() => history.push(`/Skills/list/${item}`)}
            >
              <p>{item}</p>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

export default SkillsList;
